module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer016"
    }
  }, [_c('p', {
    staticClass: "F--BM-heads"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style CharOverride-1"
  }, [_vm._v("vii")]), _c('span', {
    staticClass: "com-rorohiko-pagestaker-style _idGenCharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_c('img', {
    staticClass: "star",
    attrs: {
      "alt": "stars",
      "src": "image/GettyImages-1271638274.png"
    }
  }), _vm._v(" Contents "), _c('img', {
    staticClass: "star",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-f--bm"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC#_idTextAnchor002"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC1#_idTextAnchor003"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("1")]), _c('br'), _vm._v("The Basics of a Group Practice "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC3#_idTextAnchor004"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("2")]), _c('br'), _vm._v("Ritual Basics "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  }), _vm._v(" 29")]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC5#_idTextAnchor005"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("3")]), _c('br'), _vm._v("Some Types of Modern Covens "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "com-rorohiko-pagestaker-style CharOverride-2"
  }, [_vm._v("viii")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC7#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("4")]), _c('br'), _vm._v("Getting Started "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC9#_idTextAnchor007"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("5")]), _c('br'), _vm._v("Celebrating the sabbats "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC11#_idTextAnchor008"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("6")]), _c('br'), _vm._v("Celebrating the full moon and the lunar Cycle "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  }), _c('span', {
    staticClass: "com-rorohiko-pagestaker-style CharOverride-2"
  }, [_vm._v("ix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC13#_idTextAnchor009"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("7")]), _c('br'), _vm._v("the Crafty Coven "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC15#_idTextAnchor010"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("8")]), _c('br'), _vm._v("Rituals with a Purpose "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-1271638274.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC17#_idTextAnchor011"
    }
  }, [_c('span', {
    staticClass: "section-number-toc _idGenCharOverride-2"
  }, [_vm._v("Section ")]), _vm._v("9")]), _c('br'), _vm._v("Spirit and Divination "), _c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "star",
      "src": "image/GettyImages-12716382741.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "com-rorohiko-pagestaker-style CharOverride-2"
  }, [_vm._v("x")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-f--bm"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC19#_idTextAnchor012"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-f--bm"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC20#_idTextAnchor013"
    }
  }, [_vm._v("Appendix")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-f--bm"
  }, [_c('a', {
    attrs: {
      "href": "#/EWC21#_idTextAnchor014"
    }
  }, [_vm._v("Recommended Reading")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0